import styled from 'styled-components';
import {animations, colors} from '../../utils/styled/_variables.styled';

export const KoerberLink = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    transition: ${animations.buttonLink};
    cursor: pointer;

    color: ${props => props.inverted
        ? colors.white
        : props.disabled 
            ? colors.gray4
            : colors.blue
    };
    
    pointer-events: ${props => props.disabled 
        ? 'none' 
        : 'auto'
    };
  
    opacity: ${props => props.disabled 
        ? '0.64' 
        : '1'
    };

    &:hover {
        color: ${props => props.inverted ? colors.white : colors.blueHover};
        opacity: ${props => props.inverted ? .64 : 1};
        
        svg {
            opacity: ${props => props.inverted ? .64 : 1};
            
            path {
                fill: ${props => props.inverted ? colors.white : colors.blueHover};
            }
        }
    }
    
    &:active {
        color: ${colors.bluePressed};

        svg {
            path {
                fill: ${colors.bluePressed}
            }
        }
    }

    svg {
        margin-left: 12px;

        display: ${props => props.noIcon ? "none" : "flex"};

        path {
            transition: ${animations.buttonLink};
            fill: ${props => props.inverted
                ? colors.white
                : props.disabled 
                    ? colors.gray4
                    : colors.blue
            };
        };
    };
`;
